export const CURRENCY = {
  THB: "THB",
  B: "฿"
};
